import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { UnitType } from '../../../../../models/enums/unit-type.enum';
import { IceapiService } from '../../../../../services';
import { DataService } from '../../../../../services/data.service';
import { MeasurementService } from '../../../../../services/measurement.service';
import { GasketDimensionModel, GasketModel } from '../../../models';
import { ControlData } from '../../../models/control-data';
import { DiagramDimensionValidationModel } from '../../../models/diagram-dimension-validation-model';
import { DiagramInfo } from '../../../models/diagram-info';
import { DiagramMappings } from '../../../models/diagram-mappings';
import { GasketDimensionValuesRtjModel } from '../../../models/gasket-dimension-values-rtj-model';
import { Router } from '@angular/router';
import { CalculationType } from '../../../enums/calculation-type.enum';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-diagram-gasket-overrides',
    templateUrl: './diagram-gasket-overrides.component.html',
    styleUrls: ['./diagram-gasket-overrides.component.scss'],
})
export class DiagramGasketOverridesComponent implements OnInit {
    @Input()
    set diagramInfo(value: DiagramInfo) {
        this._diagramInfo = value;
        if (value !== undefined && value !== null) {
            this.loadDiagramData();
        }
    }
    get diagramInfo(): DiagramInfo {
        return this._diagramInfo;
    }

    @Input()
    set isEditable(value: boolean) {
        this._isEditable = value;
        // if (value) this.setFormValues();
    }
    get isEditable(): boolean {
        return this._isEditable;
    }

    @Input()
    set ringNumber(value: string) {
        this._ringNumber = value;
        if (value !== undefined && value !== null) {
            this.getgasketDimensionsValuesRtj();
        }
    }
    get ringNumber(): string {
        return this._ringNumber;
    }
    @Input() isRedirect: boolean;
    @Input() calculationType: CalculationType;
    @Output() CalcOverrides: EventEmitter<ControlData> = new EventEmitter();
    @Output() DiagramFormData: EventEmitter<any> = new EventEmitter();
    destroy$ = new Subject();

    loading: boolean = false;
    diagramDimensions: DiagramDimensionValidationModel[];
    gasketDimensions: GasketDimensionModel;
    gasketDimensionsValuesRtjs: GasketDimensionValuesRtjModel;
    diagramMappings: Map<string, DiagramMappings>;
    gasketDiagramFormGroup: UntypedFormGroup;
    gasketDegreesDefault: string = '0.00 mm';
    gasketHeightDefault: string = '0.00 mm';
    gasketIDDefault: string = '0.00 mm';
    gasketODDefault: string = '0.00 mm';
    gasketPitchDiameterDefault: string = '0.00 mm';
    gasketRingIDDefault: string = '0.00 mm';
    gasketRingODDefault: string = '0.00 mm';
    gasketWidthDefault: string = '0.00 mm';
    gasketThickness: string = '0.00 mm';
    widthOfFlat: string = '0.00 mm';
    sekectedgasket: GasketModel;

    private _diagramInfo: DiagramInfo;
    private _isEditable: boolean;
    private _ringNumber: string;

    constructor(
        private fb: UntypedFormBuilder,
        private iceapi: IceapiService,
        private measSvc: MeasurementService,
        private dataSvc: DataService,
        private cd: ChangeDetectorRef,
        private user_utility: UserUtilityService,
        private globalEmittersService: GlobalEmittersService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.loadDefaultValues();

        this.gasketDiagramFormGroup = this.fb.group({
            gasketDegrees: [this.gasketDegreesDefault, { updateOn: 'blur' }],
            gasketHeight: [this.gasketHeightDefault, { updateOn: 'blur' }],
            gasketID: [this.gasketIDDefault, { updateOn: 'blur' }],
            gasketOD: [this.gasketODDefault, { updateOn: 'blur' }],
            gasketPitchDiameter: [this.gasketPitchDiameterDefault, { updateOn: 'blur' }],
            gasketRingID: [this.gasketRingIDDefault, { updateOn: 'blur' }],
            gasketRingOD: [this.gasketRingODDefault, { updateOn: 'blur' }],
            gasketWidth: [this.gasketWidthDefault, { updateOn: 'blur' }],
            gasketThickness: [this.gasketThickness, { updateOn: 'blur' }],
            widthOfFlat: [this.widthOfFlat, { updateOn: 'blur' }],
        });
        this.gasketDiagramFormGroup
            .get('gasketHeight')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('gasketHeight', value);
                }
            });
        this.gasketDiagramFormGroup
            .get('gasketID')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('gasketID', value);
                }
            });
        this.gasketDiagramFormGroup
            .get('gasketOD')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('gasketOD', value);
                }
            });
        this.gasketDiagramFormGroup
            .get('gasketPitchDiameter')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('gasketPitchDiameter', value);
                }
            });
        this.gasketDiagramFormGroup
            .get('gasketRingID')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('gasketRingID', value);
                }
            });
        this.gasketDiagramFormGroup
            .get('gasketRingOD')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('gasketRingOD', value);
                }
            });
        this.gasketDiagramFormGroup
            .get('gasketWidth')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('gasketWidth', value);
                }
            });
        this.gasketDiagramFormGroup
            .get('gasketThickness')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                {
                    if (value) {
                        this.setItemAndEmit('gasketThickness', value);
                    }
                }
            });
        this.gasketDiagramFormGroup.get('widthOfFlat').valueChanges.subscribe((value) => {
            if (value) {
                this.setItemAndEmit('widthOfFlat', value);
            }
        });
        //this.gasketDiagramFormGroup.get('gasketDegrees').valueChanges.subscribe(value => this.setItemAndEmit('','gasketDegrees', value));

        //this.gasketDiagramFormGroup.get('gasketDegrees').valueChanges.subscribe(value => this.setItemAndEmit('','gasketDegrees', value));

        this.globalEmittersService.selectedGasket.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.sekectedgasket = res;
        });
    }

    loadDefaultValues() {
        if (this.isRedirect && this.dataSvc.calculationData != null && this.dataSvc.calculationData.input.dimensionOverrides !== null) {
            if (this.dataSvc.calculationData.input.calculationType == CalculationType.OverriddenFlange) {
                this.isEditable = true;
                // this.setFormValues();
            }
            this.gasketDegreesDefault = this.dataSvc.calculationData.input?.dimensionOverrides?.gasketDegrees ?? '0.00 mm';
            this.gasketHeightDefault = this.dataSvc.calculationData.input?.dimensionOverrides?.gasketHeight ?? '0.00 mm';
            this.gasketIDDefault = this.dataSvc.calculationData.input?.dimensionOverrides?.gasketID ?? '0.00 mm';
            this.gasketODDefault = this.dataSvc.calculationData.input?.dimensionOverrides?.gasketOD ?? '0.00 mm';
            this.gasketPitchDiameterDefault = this.dataSvc.calculationData.input?.dimensionOverrides?.gasketPitchDiameter ?? '0.00 mm';
            this.gasketRingIDDefault = this.dataSvc.calculationData.input?.dimensionOverrides?.gasketRingID ?? '0.00 mm';
            this.gasketRingODDefault = this.dataSvc.calculationData.input?.dimensionOverrides?.gasketRingOD ?? '0.00 mm';
            this.gasketWidthDefault = this.dataSvc.calculationData.input?.dimensionOverrides?.gasketWidth ?? '0.00 mm';
            this.gasketThickness = this.dataSvc.calculationData.input?.dimensionOverrides?.gasketThickness ?? '0.00 mm';
            this.widthOfFlat = this.dataSvc.calculationData.input?.dimensionOverrides?.widthOfFlat ?? '0.00 mm';
        }
    }

    initialize() {
        this.gasketDiagramFormGroup.get('gasketHeight').setValue(this.gasketHeightDefault, { emitEvent: false });
        this.gasketDiagramFormGroup.get('gasketID').setValue(this.gasketIDDefault, { emitEvent: false });
        this.gasketDiagramFormGroup.get('gasketOD').setValue(this.gasketODDefault, { emitEvent: false });
        this.gasketDiagramFormGroup.get('gasketPitchDiameter').setValue(this.gasketPitchDiameterDefault, { emitEvent: false });
        this.gasketDiagramFormGroup.get('gasketRingID').setValue(this.gasketRingIDDefault, { emitEvent: false });
        this.gasketDiagramFormGroup.get('gasketRingOD').setValue(this.gasketRingODDefault, { emitEvent: false });
        this.gasketDiagramFormGroup.get('gasketWidth').setValue(this.gasketWidthDefault, { emitEvent: false });
        this.gasketDiagramFormGroup.get('gasketThickness').setValue(this.gasketThickness, { emitEvent: false });
        this.gasketDiagramFormGroup.get('widthOfFlat').setValue(this.widthOfFlat, { emitEvent: false });
    }

    async loadDiagramData() {
        if (this.diagramInfo.diagramId === null || this.diagramInfo.diagramId === undefined) {
            this.diagramDimensions = [];
        } else {
            await this.getDiagramDimensions();
            if (this.ringNumber) {
                this.getgasketDimensionsValuesRtj();
            } else {
                await this.getgasketDimensions();
            }
            if (this.isEditable) this.setFormValues();
            this.cd.markForCheck();
        }
    }

    async getDiagramDimensions() {
        if (this.diagramInfo !== undefined) {
            await this.iceapi
                .getDiagramDimensionValidations(this.diagramInfo.diagramId, 'Gasket')
                .toPromise()
                .then((res) => {
                    if (res.success == true) {
                        this.diagramDimensions = res.response;
                    }
                })
                .catch((e) => {
                    console.warn(e);
                });

            if (this.diagramDimensions !== null) {
                if (this.calculationType == CalculationType.CustomFlange) {
                    this.initialize();
                }
                this.loadDiagramMappings();
                Object.keys(this.gasketDiagramFormGroup.controls).forEach((controlName) => {
                    const control = this.gasketDiagramFormGroup.get(controlName);

                    // You can now use controlName and control (which is a FormControl)
                    let match = this.diagramDimensions.findIndex((x) => x.key == controlName);
                    if (match <= -1) {
                        control.setValue(null);
                    }
                });
                this.DiagramFormData.emit(this.gasketDiagramFormGroup);
                if (this.isEditable) {
                    this.setValidations();
                }
            }
        }
    }

    async getgasketDimensions() {
        if ((this.ringNumber === null || this.ringNumber === undefined) && this.diagramInfo !== undefined) {
            await this.iceapi
                .getGasketDimension(this.diagramInfo.gasketTypeId, this.diagramInfo.pressureClassId, this.diagramInfo.pipesizeId)
                .toPromise()
                .then((res) => {
                    if (res.success === true) {
                        this.gasketDimensions = res.response;
                    } else {
                        this.user_utility.errorModelPopup(res.message);
                    }
                })
                .catch((e) => {
                    console.warn(e);
                });
            if (this.gasketDimensions !== null) {
                for (var key of this.diagramMappings.keys()) {
                    let value = '0.00 mm';
                    switch (key) {
                        case 'gasketID':
                            value = this.measSvc.getUserPreferedValue(this.gasketDimensions?.gasketInsideDiameter, UnitType.DefaultLengthUnit);
                            break;
                        case 'gasketOD':
                            value = this.measSvc.getUserPreferedValue(this.gasketDimensions?.gasketOutsideDiameter, UnitType.DefaultLengthUnit);
                            break;
                        case 'gasketRingID':
                            value = this.measSvc.getUserPreferedValue(this.gasketDimensions?.ringInsideDiameter, UnitType.DefaultLengthUnit);
                            break;
                        case 'gasketRingOD':
                            value = this.measSvc.getUserPreferedValue(this.gasketDimensions?.ringOutsideDiameter, UnitType.DefaultLengthUnit);
                            break;
                        case 'gasketThickness':
                            value = this.measSvc.getUserPreferedValue(this.gasketDimensions?.gasketThickness, UnitType.DefaultLengthUnit);
                            break;
                    }
                    this.diagramMappings.get(key).value = value;
                    this.cd.markForCheck();
                }
                this.cd.markForCheck();
            }
        }
    }

    async getgasketDimensionsValuesRtj() {
        if (this.diagramDimensions !== undefined || this.diagramDimensions !== null) {
            await this.getDiagramDimensions();
        }
        await this.iceapi
            .getGasketDimensionValuesRtj(this.ringNumber)
            .toPromise()
            .then((res) => {
                if (res.success === true) {
                    this.gasketDimensionsValuesRtjs = res.response;
                } else {
                    this.user_utility.errorModelPopup(res.message);
                }
            })
            .catch((e) => {
                console.warn(e);
            });
        if (this.gasketDimensionsValuesRtjs !== null) {
            for (var key of this.diagramMappings.keys()) {
                let value = '0.00 mm';
                switch (key) {
                    case 'gasketHeight':
                        if (this.sekectedgasket?.isRtj == true) {
                            if (this.sekectedgasket?.isRtj == true && this.sekectedgasket?.isOval == false) {
                                value = this.measSvc.getUserPreferedValue(this.gasketDimensionsValuesRtjs.octagonalHeight, UnitType.DefaultLengthUnit);
                            } else if (this.sekectedgasket?.isRtj == true && this.sekectedgasket?.isOval == true) {
                                value = this.measSvc.getUserPreferedValue(this.gasketDimensionsValuesRtjs.ovalHeight, UnitType.DefaultLengthUnit);
                            }
                        } else {
                            value = this.measSvc.getUserPreferedValue(this.gasketDimensionsValuesRtjs.octagonalHeight, UnitType.DefaultLengthUnit);
                        }
                        break;
                    case 'gasketWidth':
                        value = this.measSvc.getUserPreferedValue(this.gasketDimensionsValuesRtjs.width, UnitType.DefaultLengthUnit);
                        break;
                    case 'gasketPitchDiameter':
                        value = this.measSvc.getUserPreferedValue(this.gasketDimensionsValuesRtjs.pitchDiameter, UnitType.DefaultLengthUnit);
                        break;
                    case 'widthOfFlat':
                        value = this.measSvc.getUserPreferedValue(this.gasketDimensionsValuesRtjs.widthOfFlat, UnitType.DefaultLengthUnit);
                        break;
                }
                this.diagramMappings.get(key).value = value;
                this.cd.markForCheck();
            }
            this.cd.markForCheck();
        }
    }

    setItemAndEmit(controlName: string, value: string) {
        let correctedValue = this.measSvc.format(value, UnitType.DefaultLengthUnit);
        this.gasketDiagramFormGroup.get(controlName).patchValue(correctedValue, { emitEvent: false });

        let dimension = this.diagramDimensions.find((x) => x.key == controlName);
        if (dimension) {
            if (dimension !== null && (dimension.high !== null || dimension.low !== null)) {
                if (dimension.high !== undefined && dimension.high !== null) {
                    this.gasketDiagramFormGroup.controls[dimension.high].updateValueAndValidity({ emitEvent: false });
                    this.emitOverrides(dimension.high, this.gasketDiagramFormGroup.controls[dimension.high].value);
                }
                if (dimension.low !== undefined && dimension.low !== null) {
                    this.gasketDiagramFormGroup.controls[dimension.low].updateValueAndValidity({ emitEvent: false });
                    this.emitOverrides(dimension.low, this.gasketDiagramFormGroup.controls[dimension.low].value);
                }
            }
        }
        this.emitOverrides(controlName, correctedValue);
        // this.setErrorsOnToolTip();
        this.setErrorMessage();
    }

    emitOverrides(controlName: string, correctedValue: string) {
        this.CalcOverrides.emit({ controlName: controlName, controlValue: correctedValue, isFormValid: this.gasketDiagramFormGroup.valid });
        this.DiagramFormData.emit(this.gasketDiagramFormGroup);
    }

    setErrorMessage() {
        if (this.gasketDiagramFormGroup.invalid) {
            this.diagramDimensions.forEach((x) => {
                if (x.low && x.high) {
                    this.diagramMappings.get(x.key).toolTip =
                        'The value must be within ' + this.gasketDiagramFormGroup.get(x.low).value + ' - ' + this.gasketDiagramFormGroup.get(x.high).value;
                } else if (x.low) {
                    this.diagramMappings.get(x.key).toolTip = 'The value must be equal to or greater than ' + this.gasketDiagramFormGroup.get(x.low).value;
                } else if (x.high) {
                    this.diagramMappings.get(x.key).toolTip = 'The value must be equal to or lesser than ' + this.gasketDiagramFormGroup.get(x.high).value;
                }
            });
        }
    }

    loadDiagramMappings() {
        // file deepcode ignore CollectionUpdatedButNeverQueried: <please specify a reason of ignoring this>
        this.diagramMappings = new Map<string, DiagramMappings>();
        for (var dimension of this.diagramDimensions) {
            this.diagramMappings.set(dimension?.key, new DiagramMappings());
        }
    }

    setValidations() {
        this.gasketDiagramFormGroup.clearValidators();
        for (var dimension of this.diagramDimensions) {
            let controlName = dimension?.key;

            if (dimension?.low !== undefined && dimension?.low !== null && dimension?.high !== undefined && dimension?.high !== null) {
                let lowCtrlName = dimension?.low;
                let highCtrlName = dimension?.high;

                this.gasketDiagramFormGroup
                    .get(controlName)
                    .setValidators([
                        Validators.required,
                        (control: AbstractControl) =>
                            Validators.min(this.measSvc.extractNumarical(this.gasketDiagramFormGroup.controls[lowCtrlName].value))(control),
                        (control: AbstractControl) =>
                            Validators.max(this.measSvc.extractNumarical(this.gasketDiagramFormGroup.controls[highCtrlName].value))(control),
                    ]);
            } else if (dimension?.low !== undefined && dimension?.low !== null) {
                let lowCtrlName = dimension?.low;
                this.gasketDiagramFormGroup
                    .get(controlName)
                    .setValidators([
                        Validators.required,
                        (control: AbstractControl) =>
                            Validators.min(this.measSvc.extractNumarical(this.gasketDiagramFormGroup.controls[lowCtrlName].value))(control),
                    ]);
            } else if (dimension?.high !== undefined && dimension?.high != null) {
                let highCtrlName = dimension?.high;
                this.gasketDiagramFormGroup
                    .get(controlName)
                    .setValidators([
                        Validators.required,
                        (control: AbstractControl) =>
                            Validators.max(this.measSvc.extractNumarical(this.gasketDiagramFormGroup.controls[highCtrlName].value))(control),
                    ]);
            }
        }
        this.gasketDiagramFormGroup.updateValueAndValidity();
    }

    setFormValues() {
        if (this.router.url === '/informate/standardflange/false') {
            if (this.gasketDimensionsValuesRtjs) {
                if (this.sekectedgasket.isRtj == true) {
                    if (this.sekectedgasket.isRtj == true && this.sekectedgasket.isOval == false) {
                        this.gasketHeightDefault = this.measSvc.getUserPreferedValue(
                            this.gasketDimensionsValuesRtjs.octagonalHeight,
                            UnitType.DefaultLengthUnit
                        );
                    } else if (this.sekectedgasket.isRtj == true && this.sekectedgasket.isOval == true) {
                        this.gasketHeightDefault = this.measSvc.getUserPreferedValue(this.gasketDimensionsValuesRtjs.ovalHeight, UnitType.DefaultLengthUnit);
                    }
                } else {
                    this.gasketHeightDefault = this.measSvc.getUserPreferedValue(this.gasketDimensionsValuesRtjs.octagonalHeight, UnitType.DefaultLengthUnit);
                }

                this.gasketPitchDiameterDefault = this.measSvc.getUserPreferedValue(this.gasketDimensionsValuesRtjs.pitchDiameter, UnitType.DefaultLengthUnit);
                this.widthOfFlat = this.measSvc.getUserPreferedValue(this.gasketDimensionsValuesRtjs.widthOfFlat, UnitType.DefaultLengthUnit);
                this.gasketWidthDefault = this.measSvc.getUserPreferedValue(this.gasketDimensionsValuesRtjs.width, UnitType.DefaultLengthUnit);
            } else if (this.gasketDimensions) {
                this.gasketIDDefault = this.measSvc.getUserPreferedValue(this.gasketDimensions?.gasketInsideDiameter, UnitType.DefaultLengthUnit);
                this.gasketODDefault = this.measSvc.getUserPreferedValue(this.gasketDimensions?.gasketOutsideDiameter, UnitType.DefaultLengthUnit);
                this.gasketRingIDDefault = this.measSvc.getUserPreferedValue(this.gasketDimensions?.ringInsideDiameter, UnitType.DefaultLengthUnit);
                this.gasketRingODDefault = this.measSvc.getUserPreferedValue(this.gasketDimensions?.ringOutsideDiameter, UnitType.DefaultLengthUnit);
                this.gasketThickness = this.measSvc.getUserPreferedValue(this.gasketDimensions?.gasketThickness, UnitType.DefaultLengthUnit);
            }

            this.gasketDiagramFormGroup.get('gasketHeight').setValue(this.gasketHeightDefault);
            this.gasketDiagramFormGroup.get('gasketID').setValue(this.gasketIDDefault);
            this.gasketDiagramFormGroup.get('gasketOD').setValue(this.gasketODDefault);
            this.gasketDiagramFormGroup.get('gasketPitchDiameter').setValue(this.gasketPitchDiameterDefault);
            this.gasketDiagramFormGroup.get('gasketRingID').setValue(this.gasketRingIDDefault);
            this.gasketDiagramFormGroup.get('gasketRingOD').setValue(this.gasketRingODDefault);
            this.gasketDiagramFormGroup.get('gasketWidth').setValue(this.gasketWidthDefault);
            this.gasketDiagramFormGroup.get('gasketThickness').setValue(this.gasketThickness);
            this.gasketDiagramFormGroup.get('widthOfFlat').setValue(this.widthOfFlat);

            this.setValidations();
        }
    }
}
